import $ from 'jquery';

const filterSelect = $('#casino--component-games-filters .filter-select');

function setFilter(filter: string = '', value: string = '') {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    urlParams.set(filter, value);

    if (urlParams.has('page')) {
        urlParams.delete('page');
    }

    window.location.search = urlParams.toString();
}

if (filterSelect.length) {
    filterSelect.on('change', function (e) {
        const select = e.target as HTMLSelectElement;
        const optionSelected = $('option:selected', this);
        const filter = select.name;
        const value = optionSelected.val() as string;
        setFilter(filter, value);
    });
}
